import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SitesyncLogo from 'assets/images/logo.png';
import { navs } from 'utils/constants/nav';
import { cookie } from 'utils/cookies';
import './Sidebar.scss';

import {
  IconFileText,
  IconFilePlus,
  IconListDetails,
  IconBriefcase,
  IconUsers,
  IconClipboardList,
  IconLayoutDashboard,
  IconArchive
} from '@tabler/icons-react';

const getNavIcon = (name) => {
  switch (name) {
    case 'Dashboard': return <IconLayoutDashboard size={20} stroke={2} />;
    case 'Commissioning Forms': return <IconFileText size={20} stroke={2} />;
    case 'Create Forms': return <IconFilePlus size={20} stroke={2} />;
    case 'Form List': return <IconListDetails size={20} stroke={2} />;
    case 'Contractor View': return <IconBriefcase size={20} stroke={2} />;
    case 'User Management': return <IconUsers size={20} stroke={2} />;
    case 'Assignment': return <IconClipboardList size={20} stroke={2} />;
    case 'Archived': return <IconArchive size={20} stroke={2} />;
    default: return <IconFileText size={20} stroke={2} />;
  }
};

const Sidebar = () => {
  const location = useLocation();
  const userRole = cookie.get('user-role');
  return (
    <>
      <aside className="navbar navbar-vertical navbar-expand-lg premium-sidebar">
        <div className="container-fluid">
          <Link to="/" className="d-flex justify-content-center gap-2 ">
            <img src={SitesyncLogo} height="50" alt="Sitesync Logo" />
            <h1 className="navbar-brand navbar-brand-autodark mt-1">SiteSync</h1>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebar-menu"
            aria-controls="sidebar-menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="sidebar-menu">
            <ul className="navbar-nav pt-lg-3">
              {navs.map(
                (nav) =>
                  nav.rolesAllowed.includes(userRole) && (
                    <li key={nav.name.toLowerCase()} className={location.pathname.includes(nav.path) ? 'nav-item active' : 'nav-item'}>
                      <Link className="nav-link" to={nav.path}>
                        <span className="nav-icon">{getNavIcon(nav.name)}</span>
                        <span className="nav-link-title">{nav.name}</span>
                      </Link>
                    </li>
                  )
              )}
            </ul>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
